import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import authReducer from './store/reducers/auth';
import appReducer from './store/reducers/app';
import accountReducer from './store/reducers/account';
import dashboardReducer from './store/reducers/dashboard';
import newVehicleReducer from './store/reducers/newVehicle';
import vehiclesReducer from './store/reducers/vehicles';
import blackbookReducer from './store/reducers/blackbook';
import messageReducer from './store/reducers/messages';
import {reducer as QualifyVehicleReducer} from './store/reducers/qualifyVehicle';
import thunk from 'redux-thunk';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
// import Amplify, {Auth} from 'aws-amplify';
// import amplifyConfig from "./config/amplify";
import {BrowserRouter} from "react-router-dom";
import Auth0Config from "./config/auth0";

// Amplify.configure(amplifyConfig);
// Auth.configure();
Auth0Config.configure();

const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const rootReducer = combineReducers({
    auth: authReducer,
    app: appReducer,
    dashboard: dashboardReducer,
    account: accountReducer,
    newVehicle: newVehicleReducer,
    vehicles: vehiclesReducer,
    blackbook: blackbookReducer,
    messages: messageReducer,
    qualifyVehicle: QualifyVehicleReducer,
});

const store = createStore(rootReducer, compose(
    applyMiddleware(thunk),
    window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f
));

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
